<div class="modal-header">
  <h5 class="modal-title text-center ml-auto mr-auto">{{ (state === 'desired' ? 'select_rank_desired' : 'select_rank') | translate: lang }}</h5>
  <button (click)="modalService.closeOutletModals('public')" type="button" class="close" data-dismiss="modal"
          aria-label="Close">
    <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
  </button>
</div>
<div class="modal-body">
  <div class="row" style="font-style: italic;text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.75);">
    <div class="col-md text-center">
      <div *ngIf="min === 0" class="rank-select-item" (click)="onSelect(0)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/0.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(0, 'cs2')">
        <div>{{DivisionsService.getMasteryName(0, 'cs2')}}</div>
      </div>
      <div class="rank-select-item" (click)="onSelect(1)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/1.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(1, 'cs2')">
        <div>{{DivisionsService.getMasteryName(1, 'cs2')}}</div>
      </div>
      <div class="rank-select-item" (click)="onSelect(2)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/2.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(2, 'cs2')">
        <div>{{DivisionsService.getMasteryName(2, 'cs2')}}</div>
      </div>
      <div class="rank-select-item" (click)="onSelect(3)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/3.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(3, 'cs2')">
        <div>{{DivisionsService.getMasteryName(3, 'cs2')}}</div>
      </div>
    </div>
    <div class="col-md text-center">
      <div class="rank-select-item" (click)="onSelect(4)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/4.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(4, 'cs2')">
        <div>{{DivisionsService.getMasteryName(4, 'cs2')}}</div>
      </div>
      <div class="rank-select-item" (click)="onSelect(5)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/5.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(5, 'cs2')">
        <div>{{DivisionsService.getMasteryName(5, 'cs2')}}</div>
      </div>
      <div class="rank-select-item" (click)="onSelect(6)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/6.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(6, 'cs2')">
        <div>{{DivisionsService.getMasteryName(6, 'cs2')}}</div>
      </div>
      <div class="rank-select-item" (click)="onSelect(7)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/7.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(7, 'cs2')">
        <div>{{DivisionsService.getMasteryName(7, 'cs2')}}</div>
      </div>
    </div>
    <div class="col-md text-center">
      <div class="rank-select-item" (click)="onSelect(8)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/8.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(8, 'cs2')">
        <div>{{DivisionsService.getMasteryName(8, 'cs2')}}</div>
      </div>
      <div class="rank-select-item" (click)="onSelect(9)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/9.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(9, 'cs2')">
        <div>{{DivisionsService.getMasteryName(9, 'cs2')}}</div>
      </div>
      <div class="rank-select-item" (click)="onSelect(10)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/10.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(10, 'cs2')">
        <div>{{DivisionsService.getMasteryName(10, 'cs2')}}</div>
      </div>
      <div class="rank-select-item" (click)="onSelect(11)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/11.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(11, 'cs2')">
        <div>{{DivisionsService.getMasteryName(11, 'cs2')}}</div>
      </div>
    </div>
    <div class="col-md text-center">
      <div class="rank-select-item" (click)="onSelect(12)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/12.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(12, 'cs2')">
        <div>{{DivisionsService.getMasteryName(12, 'cs2')}}</div>
      </div>
      <div class="rank-select-item" (click)="onSelect(13)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/13.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(13, 'cs2')">
        <div>{{DivisionsService.getMasteryName(13, 'cs2')}}</div>
      </div>
      <div class="rank-select-item" (click)="onSelect(14)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/14.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(14, 'cs2')">
        <div>{{DivisionsService.getMasteryName(14, 'cs2')}}</div>
      </div>
      <div class="rank-select-item" (click)="onSelect(15)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/15.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(15, 'cs2')">
        <div>{{DivisionsService.getMasteryName(15, 'cs2')}}</div>
      </div>
    </div>
    <div class="col-md text-center">
      <div class="rank-select-item" (click)="onSelect(16)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/16.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(16, 'cs2')">
        <div>{{DivisionsService.getMasteryName(16, 'cs2')}}</div>
      </div>
      <div class="rank-select-item" (click)="onSelect(17)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/17.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(17, 'cs2')">
        <div>{{DivisionsService.getMasteryName(17, 'cs2')}}</div>
      </div>
      <div *ngIf="max === 181" class="rank-select-item" (click)="onSelect(18)">
        <img height="60" src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/18.webp' | cdn}}" [alt]="DivisionsService.getMasteryName(18, 'cs2')">
        <div>{{DivisionsService.getMasteryName(18, 'cs2')}}</div>
      </div>
    </div>
  </div>
</div>
